import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const CategoryLogoDesignLargeIcon = ({
    size = 24,
    color = 'currentFill'
}: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 33 32"
        fill={color}
        xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd"
            clipRule="evenodd"
            d="M17.665 24.333v7.334h-2v-7.334h2Z"
            fill="#404145"/>
        <path fillRule="evenodd"
            clipRule="evenodd"
            d="M6.332 13.667h2.333a9 9 0 0 1 9 9v3.666h-2.333a9 9 0 0 1-9-9v-3.666Zm2 2v1.666a7 7 0 0 0 7 7h.333v-1.666a7 7 0 0 0-7-7h-.333Z"
            fill="#404145"/>
        <path fillRule="evenodd"
            clipRule="evenodd"
            d="M17.999 24.333a7 7 0 0 0 7-7v-1.666h-.334a7 7 0 0 0-7 7v1.666H18Zm6.364-.636a9 9 0 0 1-6.364 2.636h-2.334v-3.666a9 9 0 0 1 9-9H27v3.666a9 9 0 0 1-2.636 6.364ZM16.665 1.358l.646.545a8.553 8.553 0 0 1 3.02 6.04l.003.057-.004.058a8.555 8.555 0 0 1-3.02 6.04l-.645.544-.645-.545A8.554 8.554 0 0 1 13 8.057L12.997 8 13 7.942a8.553 8.553 0 0 1 3.02-6.04l.645-.544Zm0 2.698A6.552 6.552 0 0 0 15.001 8a6.554 6.554 0 0 0 1.664 3.944A6.555 6.555 0 0 0 18.33 8a6.554 6.554 0 0 0-1.665-3.944Z"
            fill="#404145"/>
    </svg>
);
CategoryLogoDesignLargeIcon.displayName = 'CategoryLogoDesignLargeIcon';
export default CategoryLogoDesignLargeIcon;
